// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/dashboard/Dashboard';
import PCRFormPage from './components/pcr/PCRFormPage';
import AdminDashboard from './components/admin/AdminDashboard';
import UserManagement from './components/admin/UserManagement';
import { FormProvider } from './contexts/FormContext';
import PrivateRoute from './components/auth/PrivateRoute';
import GlobalResources from './components/resources/GlobalResources';
import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <GlobalResources>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Admin routes */}
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              } 
            />
            
            {/* Add User Management route */}
            <Route path="/admin/users" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
            
            {/* Protected routes */}
            <Route 
              path="/" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/form/new" 
              element={
                <PrivateRoute>
                  <FormProvider>
                    <PCRFormPage />
                  </FormProvider>
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/form/:formId" 
              element={
                <PrivateRoute>
                  <FormProvider>
                    <PCRFormPage />
                  </FormProvider>
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/form/:formId/readonly" 
              element={
                <FormProvider>
                  <PCRFormPage isReadOnly={true} />
                </FormProvider>
              } 
            />
            
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </GlobalResources>
      </AuthProvider>
    </Router>
  );
}

export default App;